<template>
  <div class="datetimepicker">
    <label v-if="label" class="datetimepicker__label">{{ label }}</label>
    <TabDropdown
      :placeholder="placeholder"
      @input="handleInput"
      :position="position"
      :value="value"
      :isCalendar="true"
      :showToTop="showToTop"
      :class="custom ? 'custom' : ''"
      :disabledDate="disabledDate"
      @nm="nm"
      @pm="pm"
      @ny="ny"
      @py="py"
    />
  </div>
</template>

<script>
import TabDropdown from "@/components/TabDropdown";

export default {
  props: {
    position: {
      type: String,
      default: "absolute"
    },
    label: {
      type: String,
      default: "Date"
    },
    placeholder: {
      type: String,
      default: "Choose date"
    },
    value: {
      type: String,
      default: null
    },
    custom: {
      type: Boolean,
      default: false
    },
    showToTop: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: () => {
        return false;
      }
    }
  },
  components: {
    TabDropdown
  },
  methods: {
    handleInput(key) {
      this.$emit("input", key);
      this.$emit("change");
    },
    nm(date) {
      this.$emit("nm", date);
    },
    pm(date) {
      this.$emit("pm", date);
    },
    ny(year) {
      this.$emit("ny", year);
    },
    py(year) {
      this.$emit("py", year);
    }
  }
};
</script>

<style lang="scss" scoped>
.datetimepicker {
  &__label {
    font-size: 12px !important;
    font-weight: 500;
  }
}
</style>

<style lang="scss">
.custom {
  .tabdropdown-trigger {
    padding: 8px 14px;
    font-size: $font-size-xs;
    font-family: "Gotham Book", sans-serif;
    color: #343a40;
    width: auto;
  }
}
</style>
